<div class="br-dialog-shell publish-dialog-shell">
  <header class="br-dialog-header">
    <h2 mat-dialog-title class="br-dialog-title">Publish workflow</h2>
  </header>

  <mat-dialog-content class="br-dialog-body">
    <div class="publish-workflow-name">{{ data.label }}</div>

    <div class="publish-preview" aria-label="Workflow preview">
      <app-dynamic-workflow-graph
          [nodes]="data.nodes"
          [transitions]="data.transitions"
          [layout]="data.layout || {}"
          [readOnly]="true"
          [showControls]="false"
          [selectedNodeKey]="startNodeKey"
          [errorNodeKeys]="errorNodeKeys">
      </app-dynamic-workflow-graph>
    </div>

    <div class="publish-issues" *ngIf="issues.length" role="alert">
      <div class="publish-issue" *ngFor="let issue of issues">{{ issue.message }}</div>
    </div>

    <label class="publish-field" for="publish-start-node" *ngIf="data.nodes.length">
      <span class="br-form-label">
        Start at <span class="br-required-mark" aria-hidden="true">*</span>
      </span>
      <select
          id="publish-start-node"
          class="br-form-control"
          [(ngModel)]="startNodeKey"
          (ngModelChange)="validateSelection()"
          aria-required="true"
          required>
        <option *ngFor="let node of data.nodes" [value]="node.key">{{ node.label }}</option>
      </select>
    </label>
    <p class="publish-note" *ngIf="data.nodes.length">
      Publishing makes this workflow read only.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="br-dialog-actions">
    <button type="button" class="br-btn br-btn--secondary" mat-dialog-close>Cancel</button>
    <button type="button" class="br-btn br-btn--primary"
            *ngIf="issues.length && data.canEdit" (click)="edit()">
      Edit workflow
    </button>
    <button type="button" class="br-btn br-btn--primary"
            [disabled]="!canPublish" (click)="publish()">
      Publish
    </button>
  </mat-dialog-actions>
</div>
